<div class="deposit-account" [class.deposit-account--animated]="showAnimated">
  <button (click)="hide()" class="deposit-account__close">
    <img src="/images/erase.png" />
  </button>
  <div class="deposit-account__container">
    <div class="deposit-account__information">
      {{ informationMessage }}
    </div>
    <div *ngIf="!hasError" class="deposit-account__cash-info">
      <span class="deposit-account__bank"> Banco<strong>GBM</strong> </span>
      <div class="deposit-account__clabe" data-recording-sensitive>
        CLABE
        <copy-text-value
          [message]="'CLABE copiada en portapapeles'"
          [useNotification]="true"
          [showIcon]="true"
          [value]="formattedCLABE | mask: '000 000 00000000000 0'"
          (onCopyToClipboardEvent)="copyCLABE()"
        ></copy-text-value>
      </div>
    </div>
  </div>
</div>
